<div
    class="vertical-center height-100 section-radius"
    [ngStyle]="{
        'background-color': config?.backgroundColor && config.backgroundColor !== 'null' ? config.backgroundColor : 'transparent'
    }"
>
    <div class="title">
        {{ config?.value }}
    </div>
</div>
